import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagFJ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 11.956v8.432l-8.696-8.432H25ZM13.043 25h7.345l-7.345-9.783-1.087 7.609L13.043 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.933 25H25v-.067l-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.648 3.26a25.12 25.12 0 0 0-9.387 9.388V25h6.522V9.783H25V3.26H12.648Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25 21.926-8.882-8.882h-3.074L25 25v-3.074Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F3F3F3",
  d: "M28.26 16.305V25c0 5.825 7.61 7.61 7.61 7.61s7.608-1.785 7.608-7.61v-8.695L35.87 14.13l-7.61 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M43.478 16.305v-3.261H28.261v3.26h6.521v6.522h-6.521V25h6.521v7.276a11.53 11.53 0 0 0 1.088.333s.43-.101 1.086-.334V25h6.522v-2.174h-6.522v-6.521h6.522Z"
}));
FlagFJ.displayName = 'FlagFJ';
export default withFlagWrapper(FlagFJ);
//# sourceMappingURL=index.js.map